// import Cookies from 'js-cookie';
import actions from './actions';
import { setItemBase64, getItemBase64 } from '../../utility/localStorageControl';
const {
  SET_BALANCE,
  INCREASE_BALANCE,
  DECREASE_BALANCE,
  FETCH_BALANCE_REQUEST,
  FETCH_BALANCE_SUCCESS,
  FETCH_BALANCE_FAILURE,
} = actions;

const initState = {
  value: getItemBase64('balance') ?? 0,
  loading: false,
  error: null,
};

const BalanceReducer = (state = initState, action) => {
  const { type, amount } = action;
  switch (type) {
    case FETCH_BALANCE_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_BALANCE_SUCCESS:
      setItemBase64('balance', action.payload);
      return { ...state, loading: false, value: action.payload };
    case FETCH_BALANCE_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case SET_BALANCE:
      setItemBase64('balance', amount);
      return { ...state, value: amount };
    case INCREASE_BALANCE:
      const newIncValue = Number(state.value) + Number(amount);
      setItemBase64('balance', newIncValue);
      return { ...state, value: newIncValue };
    case DECREASE_BALANCE:
      const newDecValue = Number(state.value) - Number(amount);
      setItemBase64('balance', newDecValue);
      return { ...state, value: newDecValue };
    default:
      return state;
  }
};
export default BalanceReducer;
